// Define your brand fonts, colors, and images here

/*--------------- EY brand assets ---------------*/
export const theme = {
    fonts: {
      primary: 'EY Interstate Light',
      secondary: 'EY Interstate Bold'
    },
    colors: {
      primary: '#ffe600',
      secondary: '#2e2e38',
      background: '#f6f6fa',
      text: '#2e2e38',
      darkModeBg: '#2e2e38',
      darkModeText: '#fff'
    },
    images: {
        logo: {
          light: require('./assets/images/ey/EY_logo_3.gif'),
          dark: require('./assets/images/ey/EY_logo_6.gif'),
        },
    },
};

/*--------------- Client brand assets: JPMC ---------------*/
// export const theme = {
//   fonts: {
//     primary: "Open Sans",
//     secondary: "Open Sans"
//   },
//   colors: {
//     primary: '#0a4879',
//     secondary: '#0a4879',
//     background: '#f6f6fa',
//     text: '#2e2e38',
//     darkModeBg: '#2e2e38',
//     darkModeText: '#fff'
//   },
//   images: {
//       logo: {
//         light: require('./assets/images/jpmc/jpmc_logo_dark.jpg'),
//         dark: require('./assets/images/jpmc/jpmc_logo_light.png'),
//       },
//   },
// };

/*--------------- Client brand assets: Visa ---------------*/
// export const theme = {
//   fonts: {
//     primary: "Visa Dialect Regular",
//     secondary: "Visa Dialect Bold"
//   },
//   colors: {
//     primary: '#fcc014',
//     secondary: '#1534cb',
//     background: '#f6f6fa',
//     text: '#2e2e38',
//     darkModeBg: '#2e2e38',
//     darkModeText: '#fff'
//   },
//   images: {
//       logo: {
//         light: require('./assets/images/visa/Visa_Brandmark_White_RGB_2021.png'),
//         dark: require('./assets/images/visa/Visa_Brandmark_White_RGB_2021.png'),
//       },
//   },
// };

/*--------------- Client brand assets: Commerce Bank ---------------*/
// export const theme = {
//   fonts: {
//     primary: "Cera Pro Regular",
//     secondary: "Cera Pro Bold"
//   },
//   colors: {
//     primary: '#006747',
//     secondary: '#4fa800',
//     background: '#faf9f7',
//     text: '#77726d',
//     darkModeBg: '#2e2e38',
//     darkModeText: '#fff'
//   },
//   images: {
//       logo: {
//         light: require('./assets/images/cb/commerce-bank-logo-dark.png'),
//         dark: require('./assets/images/cb/commerce-bank-logo-light.png'),
//       },
//   },
// };